<template>
  <div>
    <div class="info row container-info">
      <div class="container">
        <div class="col-xs-12 col-lg-6 info__in">
          <div class="info__left">
            <h3 v-html="this.translation.title_step1"></h3>
            <h3 v-html="this.translation.title_step2"></h3>
          </div>
          <span v-html="translation.info_step"></span>
        </div>
        <div class="col-xs-12 col-lg-6 info__in info__right">
          <!-- link_video_right -->
          <span v-html="translation.link_video_right"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "sub-title-header-page",
  props: ["translation"],
  mounted() {
    // console.log(this.props);
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container-info {
  margin-top: 25px;
  margin-left: 10px;
  margin-right: 20px;

  .container {
    padding-right: 0;
    padding-left: 0;
  }
}
.info {
  color: #818a91;
  span {
    line-height: 25px;
  }
  .info__in {
    min-height: 120px;
  }
  .info__left {
    display: flex;
    flex-wrap: wrap;
    h3 {
      &:first-child {
        font-weight: 700;
        font-size: 1.6rem;
        margin-right: 0.5rem;
      }
      &:last-child {
        font-weight: 300;
        font-size: 1.6rem;
      }
    }
  }
  .info__right {
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      align-items: center;
      display: flex;
      flex-direction: column;
    }
    img {
      width: 300px;
      margin: 10px;
    }
  }
}
@media (max-width: 1150px) {
  .info__in {
    text-align: center;
  }
}
</style>
<style>
iframe {
  min-height: 360px;
  min-width: 500px;
}
@media (max-width: 1150px) {
  iframe {
    min-width: 320px;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/subTitleHeader.vue